import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const topics = [
  'ベビー服について',
  'その他',
];

export default function ContactSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: formRef, isVisible: formVisible } = useScrollAnimation();
  const [submitted, setSubmitted] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const message = (form.querySelector('textarea[name="message"]') as HTMLTextAreaElement)?.value || '';
    if (message.length > 500) return;

    const data = new FormData(form);
    const body = new URLSearchParams();
    data.forEach((value, key) => {
      body.append(key, value.toString());
    });

    await fetch('https://readdy.ai/api/form/d70jhjcciedc9e24mdn0', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    });
    setSubmitted(true);
  };

  return (
    <section id="contact" className="py-28 px-6 bg-[#FEFCFA]">
      <div className="max-w-3xl mx-auto">
        <div
          ref={headerRef}
          className={`text-center mb-16 fade-in ${headerVisible ? 'visible' : ''}`}
        >
          <p className="text-[#C97B7B] text-xs tracking-[0.4em] mb-4 uppercase">Contact</p>
          <h2 className="text-[#3A2E28] text-3xl md:text-4xl font-light mb-4" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            お問い合わせ
          </h2>
          <div className="w-12 h-px bg-[#C8B99A] mx-auto mb-6" />
          <p className="text-[#6B5E57] text-sm leading-loose">
            ベビー服について<br />
            お気軽にお問い合わせください。
          </p>
        </div>

        <div
          ref={formRef}
          className={`fade-in ${formVisible ? 'visible' : ''}`}
        >
          {submitted ? (
            <div className="text-center py-16">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6"
                style={{ backgroundColor: '#F7EDED' }}
              >
                <i className="ri-checkbox-circle-line text-3xl" style={{ color: '#C97B7B' }} />
              </div>
              <h3 className="text-[#3A2E28] text-xl font-light mb-4" style={{ fontFamily: 'Noto Serif JP, serif' }}>
                お問い合わせを受け付けました
              </h3>
              <p className="text-[#6B5E57] text-sm leading-loose">
                内容を確認の上、担当よりご連絡いたします。<br />
                しばらくお待ちください。
              </p>
            </div>
          ) : (
            <form
              id="contact-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="flex flex-col gap-6"
            >
              <div>
                <label className="block text-xs tracking-wider text-[#A8835A] mb-2">
                  お問い合わせ種別
                </label>
                <select
                  name="topic"
                  required
                  className="w-full border border-[#E8DFD0] rounded-md px-4 py-3 text-sm text-[#3A2E28] bg-white cursor-pointer focus:outline-none focus:border-[#A8835A]"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  <option value="">選択してください</option>
                  {topics.map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-xs tracking-wider text-[#A8835A] mb-2">
                  お名前 <span className="text-[#C97B7B]">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  placeholder="山田 太郎"
                  className="w-full border border-[#E8DFD0] rounded-md px-4 py-3 text-sm text-[#3A2E28] bg-white focus:outline-none focus:border-[#A8835A]"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                />
              </div>

              <div>
                <label className="block text-xs tracking-wider text-[#A8835A] mb-2">
                  メールアドレス <span className="text-[#C97B7B]">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="example@email.com"
                  className="w-full border border-[#E8DFD0] rounded-md px-4 py-3 text-sm text-[#3A2E28] bg-white focus:outline-none focus:border-[#A8835A]"
                />
              </div>

              <div>
                <label className="block text-xs tracking-wider text-[#A8835A] mb-2">
                  メッセージ <span className="text-[#C97B7B]">*</span>
                </label>
                <textarea
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  placeholder="お問い合わせ内容をご記入ください"
                  onChange={(e) => setCharCount(e.target.value.length)}
                  className="w-full border border-[#E8DFD0] rounded-md px-4 py-3 text-sm text-[#3A2E28] bg-white focus:outline-none focus:border-[#A8835A] resize-none"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                />
                <p className={`text-right text-xs mt-1 ${charCount > 450 ? 'text-[#C97B7B]' : 'text-[#A8835A]'}`}>
                  {charCount} / 500
                </p>
              </div>

              <button
                type="submit"
                className="w-full py-4 text-sm tracking-[0.2em] font-medium cursor-pointer hover:opacity-80 transition-opacity rounded-md whitespace-nowrap"
                style={{ backgroundColor: '#A8835A', color: '#FEFCFA', fontFamily: 'Noto Sans JP, sans-serif' }}
              >
                送信する
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
